const PERMISSION_KEY= "core:referrer_reward_plans";
const PAGE_URL = {
    REFERRER_REWARD_PLAN_PAGE: "/admin/core/referrer-reward-plan"
}

export {PERMISSION_KEY, PAGE_URL}

